import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { InterventionTableComponent } from '../../components/intervention-table/intervention-table.component';
import { DataTablePageChangedEvent } from '@shared/components/data-table.component';
import { SHARED_IMPORTS } from '../../../../../shared/modules/shared-imports.module';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { Permission } from '@shared/enums/permission.enum';
import { PermissionService } from '@core/services/permission.service';
import { InterventionStore } from '../../../intervention.store';

@Component({
  selector: 'app-intervention-list-page',
  imports: [RouterLink, InterventionTableComponent, ...SharedMaterialUIModule, ...SHARED_IMPORTS],
  templateUrl: './intervention-list.page.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class InterventionListPage {
  private readonly permissionService = inject(PermissionService);
  protected readonly store = inject(InterventionStore);
  constructor() {
    this.store.load();
  }
  protected canCreate(): boolean {
    return this.permissionService.hasPermission(Permission.InterventionsUpdate);
  }
  protected search(search: string): void {
    this.store.load({ pageNumber: 1, pageSize: this.store.pageSize() }, search);
  }
  protected pageChanged(event: DataTablePageChangedEvent): void {
    this.store.load(event);
  }
}
